import { useEffect, useState } from "react";
import { Button, Dropdown, Modal } from "../../../evo/bootstrap";
import { deleteDoc, downloadDoc, getDoc, uploadDoc } from "../../Services/chatbot";
import { toast } from "react-toastify";
import "../../assets/chatbotconfig.css"
import DeleteModal from "../DeleteModal";

const DocumentManage = ({ shouldLoadDocument, onLoaded }: any) => {
    const [formData, setFormData] = useState<any>({
        filename: "",
        data: "",       // base64 string
        documentFileName: null,
    });
    const [errors, setErrors] = useState<any>({
        filename: "",
        data: ""
    });
    const [showModal, setShowModal] = useState(false);
    const [filedata, setFileData] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [modalloading, setmodalloading] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedFileToDelete, setSelectedFileToDelete] = useState<any>(null);




    useEffect(() => {
        if (shouldLoadDocument) {
            getAllDoc();
            onLoaded();  // ✅ reset the trigger after loading
        }
    }, [shouldLoadDocument]);

    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear error as user types
        if (value.trim() !== "") {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = String(reader.result).split(',')[1]; // Remove the prefix

                setFormData((prev) => ({
                    ...prev,
                    data: reader.result, // store only pure base64
                    documentFileName: file.name,
                }));
                setErrors((prev) => ({ ...prev, document: "" }));
            };
            reader.readAsDataURL(file);
        }
    };


    const validate = () => {
        const newErrors: Record<string, any> = {};
        if (!formData.filename) {
            newErrors.filename = "Document name is required";
        }
        if (!formData.data) {
            newErrors.data = "Document file is required";
        } else {
            const allowedExtensions = ["docx", "json", "txt", "doc"];
            const extension = formData.documentFileName.split('.').pop().toLowerCase();

            if (!allowedExtensions.includes(extension)) {
                newErrors.data = "Only .docx, .json, .txt, and .doc files are allowed";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {

        if (!validate()) return;
        setmodalloading(true)
        const { documentFileName, ...apiPayload } = formData;
        let res;
        try {
            res = await uploadDoc(formData);


            if (res.status === 200) {
                setShowModal(false);
                setFormData({
                    filename: "",
                    data: "",
                    documentFileName: null
                });
                setErrors({});

                await getAllDoc();
                //setmodalloading(false)
            }
            else {
                toast.error(res.data.message || res.data.error || "Something went wrong")
            }
        } catch (error) {
            toast.error(error.message || error)
        } finally {
            setmodalloading(false)
        }

    };

    const handleOpenAddModal = () => {
        setShowModal(true);
        setErrors({});
    };
    const handleClose = () => {
        setShowModal(false);
        setFormData({})
        setErrors({});
    };

    const getAllDoc = async () => {
        setLoading(true)
        let res;
        try {
            res = await getDoc();
            if (res?.status === 200) {
                setFileData(res.data?.files)
                setLoading(false)
            } else {
                toast.error(res.data.message || res.data.error || "Something went wrong")
            }
        } catch (error) {
            if (error.status === 401) {
                toast.error("Access denied. Please verify using a valid link.");
            }
            toast.error(error.message || error)
        } finally {
            setLoading(false)
        }
    }
    const downloadFile = async (file) => {
        setLoading(true)
        try {
            const res = await downloadDoc({ filename: file });

            const base64 = res?.data?.base64_data;
            const filename = file || "downloaded_file";
            const mimeType = res?.data?.mime_type || "application/octet-stream";

            if (!base64) {
                console.error("No file data received");
                return;
            }


            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length)
                .fill(0)
                .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);


            const blob = new Blob([byteArray], { type: mimeType });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            a.click();

            URL.revokeObjectURL(url);
            setLoading(false)
        } catch (error) {
            console.error("Error downloading file:", error);
        } finally {
            setLoading(false)
        }
    };

    const deleteDocument = async (file) => {
        try {
            const res = await deleteDoc({ filename: file });

            if (res.status === 200) {
                toast.success(res.data.message || "Document deleted successfully");

                // Remove the deleted file from the state
                setFileData((prev) => prev.filter((f) => f.filename !== file));
            } else {
                toast.error(res.data.message || res.data.error || "Failed to delete document");
            }
        } catch (error) {
            toast.error(error.message || "Error deleting document");
        }
    };

    const handleConfirmDelete = async () => {
        if (!selectedFileToDelete) return;
        setLoading(true)
        try {
            const res = await deleteDoc({ filename: selectedFileToDelete });

            if (res.status === 200) {
                toast.success(res.data.message || "Document deleted successfully");
                setFileData((prev) =>
                    prev.filter((f) => f.filename !== selectedFileToDelete)
                );
            } else {
                toast.error(res.data.message || res.data.error || "Failed to delete document");
            }
        } catch (error) {
            toast.error(error.message || "Error deleting document");
        } finally {
            setShowDeleteModal(false);
            setSelectedFileToDelete(null);
            setLoading(false)
        }
    };



    return (
        <>
            <div className="position-relative">
                {loading && (
                   <div className="loaderOverlay zIndex-1023"><div className="loading"><div className="main-loader"></div></div></div>
                )}
                <div className={loading ? "blur-sm pointer-events-none" : ""}>
                    <div className="text-end mb-3">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={handleOpenAddModal}>
                            <i className="bi bi-plus-lg me-1"></i>File
                        </button>
                    </div>


                    <table className="table chat-table">
                        <thead className="thead-dark">
                            <tr>
                                <th>Document Name</th>
                                <th className="text-end">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filedata && filedata.length > 0 ? (
                                filedata.map((res, index) => (
                                    <tr key={index}>
                                        <td>{res.filename}</td>
                                        <td className="text-end">
                                            <div className="d-flex justify-content-end gap-2">
                                            <div className="col-auto">
                                                <button
                                                    type="button"
                                                    className="btn edit-btn btn-sm py-2"
                                                    onClick={() => downloadFile(res.filename)}
                                                >
                                                    <i className="bi bi-download"></i>
                                                 
                                                </button>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={() => {
                                                            setSelectedFileToDelete(res.filename);
                                                            setShowDeleteModal(true);
                                                        }}
                                                    >
                                                        <i className="bi bi-trash3"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={2} className="text-center">No files available.</td>
                                </tr>
                            )}
                        </tbody>

                    </table>

                </div>
            </div>

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalloading && (
                       <div className="loaderOverlaySection zIndex-1023"><div className="loading"><div className="main-loader"></div></div></div>
                    )}
                    <div className={loading ? "blur-sm pointer-events-none" : ""}>
                        <div className="row row-gap-4">
                            <div className="col-md-12">
                                <label className="form-label">Document Name<span style={{ color: "red" }}> *</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter document name"
                                    name="filename"
                                    value={formData.filename}
                                    onChange={onChange}
                                />
                                {errors.filename && (
                                    <div className="text-danger small mt-1">{errors.filename}</div>
                                )}

                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Document<span style={{ color: "red" }}> *</span></label>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="document"
                                    onChange={handleFileChange}
                                    accept=".docx,.json,.txt,.doc"
                                />
                                {errors.data && (
                                    <div className="text-danger small mt-1">{errors.data}</div>
                                )}

                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="btn-primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            <DeleteModal
                show={showDeleteModal}
                label={selectedFileToDelete}
                onClose={() => {
                    setShowDeleteModal(false);
                    setSelectedFileToDelete(null);
                }}
                onConfirm={handleConfirmDelete}
                mode="delete"
            />


        </>
    );
};

export default DocumentManage;
